import { Button } from '@mui/material';
import { PlayArrow, Pause } from '@mui/icons-material';
import { AdEntityType } from '../services/ad-status.service';
import { useAdStatus, useMayChangeStatus } from './ad-status';

interface Props {
  entityType: AdEntityType;
  ids: string[];
  /** Rows already in the target state, so the dialog can say the change is smaller. */
  alreadyInState?: (status: 'ACTIVE' | 'PAUSED') => number;
  onDone?: () => void;
  invalidateKey: string;
}

export default function AdStatusButtons({
  entityType, ids, alreadyInState, onDone, invalidateKey,
}: Props) {
  const mayAct = useMayChangeStatus();
  const { ask, dialogs } = useAdStatus(entityType, invalidateKey, onDone);
  if (!mayAct) return null;

  return (
    <>
      <Button size="small" startIcon={<PlayArrow />} disabled={!ids.length}
        onClick={() => ask(ids, 'ACTIVE', alreadyInState?.('ACTIVE') ?? 0)}>Activate</Button>
      <Button size="small" startIcon={<Pause />} disabled={!ids.length}
        onClick={() => ask(ids, 'PAUSED', alreadyInState?.('PAUSED') ?? 0)}>Pause</Button>
      {dialogs}
    </>
  );
}
